<template>
  <Modal :open="props.open" @close-modal="$emit('close-modal')">
    <template #modal-header>
      <div>
        <div class="flex mb-2 items-center">
          <Icon name="Pencil" class="w-4 h-4 mr-2 stroke-info" />
          <div class="text-sm font-inter font-semibold text-info">Edit</div>
        </div>
        <div class="font-league tracking-[-.56px] font-semibold text-[1.75rem] text-strongest">
          Edit Distribution Account
        </div>
      </div>
    </template>

    <template #modal-body>
      <!-- <div class="p-2 lg:p-6">
        <div v-for="bank in options">
          <BankCard
            :bank="bank"
            :custom-cta="true"
            :custom-cta-label="'Select'"
            @cta-click="$emit('confirm')"
          />
        </div>
      </div> -->
      <div class="text-strongest py-5">
        <div class="px-4">
          <div class="mb-6 lg:mb-8">
            <h3 class="text-base lg:text-lg font-semibold font-inter">
              How would you like to receive earnings from this investment?
            </h3>
            <p class="font-inter text-strong text-sm">
              Phoenix distributes interest monthly via ACH on the 10th of each month. Use Checking
              or Savings accounts.
            </p>
          </div>
          <div class="grid grid-cols-1 lg:grid-cols-3 gap-4 w-full">
            <div
              v-for="option in bankingOptions"
              @click="selectOption(option.value)"
              class="cursor-pointer rounded-xl p-4 flex items-center justify-between gap-3 h-[40px] lg:h-[72px]"
              :class="isOptionSelected(option.value) ? 'bg-radio-checkbox-selector' : ''"
            >
              <div class="flex items-center gap-3">
                <div
                  class="h-4 w-4 rounded-full flex items-center justify-center border border-radio-checkbox-outline"
                  :class="
                    isOptionSelected(option.value)
                      ? 'bg-radio-checkbox-checked border-transparent'
                      : 'bg-transparent border border-radio-checkbox-outline'
                  "
                >
                  <Icon
                    v-if="isOptionSelected(option.value)"
                    name="Check"
                    class="text-container-bg h-3 w-3"
                    :stroke-width="2.5"
                  />
                </div>
                <p
                  class="font-inter whitespace-nowrap"
                  :class="isOptionSelected(option.value) ? 'font-semibold' : 'font-medium'"
                >
                  {{ option.label }}
                </p>
              </div>
              <img
                :src="option.icon"
                :alt="option.label"
                class="h-[36px] w-[36px] lg:h-[60px] lg:w-[60px]"
              />
            </div>
          </div>
        </div>

        <div class="border-b border-outline-dividers w-full my-8" />
        <div class="px-4">
          <h3 class="text-base lg:text-lg font-semibold font-inter mb-4">
            {{ titleForOption }}
          </h3>
          <div>
            <!-- Bank Accounts -->
            <div v-if="selectedBankingOption === 'ACH'">
              <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 w-full">
                <div
                  v-for="bank in dataStore.bank_accounts"
                  @click="selectedBankAccount = bank.record_id"
                  class="cursor-pointer rounded-xl p-4 flex items-center justify-between gap-3 h-[64px] lg:h-[85px]"
                  :class="isBankSelected(bank.record_id) ? 'bg-radio-checkbox-selector' : ''"
                >
                  <div class="flex items-center gap-5">
                    <div
                      class="h-6 w-6 rounded-full flex items-center justify-center border border-radio-checkbox-outline"
                      :class="
                        isBankSelected(bank.record_id)
                          ? 'bg-radio-checkbox-checked border-transparent'
                          : 'bg-transparent border border-radio-checkbox-outline'
                      "
                    >
                      <Icon
                        v-if="isBankSelected(bank.record_id)"
                        name="Check"
                        class="text-container-bg h-4.5 w-4.5"
                        :stroke-width="2.5"
                      />
                    </div>
                    <div>
                      <p
                        class="font-inter whitespace-nowrap text-sm lg:text-lg"
                        :class="isBankSelected(bank.record_id) ? 'font-semibold' : 'font-medium'"
                      >
                        Account ending in ******
                        {{
                          bank.institution_id == "ins_56" ||
                          bank.institution_id == "ins_13" ||
                          bank.institution_id == "ins_127990"
                            ? bank.mask
                            : bank.account_number.slice(-4)
                        }}
                      </p>
                      <p
                        class="font-semibold font-inter text-sm lg:text-base"
                        :class="isBankSelected(bank.record_id) ? 'text-strong' : 'text-strong'"
                      >
                        {{ bank.account_type }} account with {{ bank.financial_institution_name }}
                      </p>
                    </div>
                  </div>
                  <img
                    v-if="bank.logo"
                    class="h-12 w-12"
                    :src="'data:image/png;base64, ' + bank.logo + ''"
                    alt="Red dot"
                  />

                  <Icon v-else name="Landmark" class="h-10 w-10 text-strongest" :stroke-width="2" />
                </div>
              </div>

              <!-- <Button
                @click="plaidLink.open('Distribution')"
                variant="paper-primary"
                class="w-auto mt-5"
                size="md-xs"
              >
                <template #label>Connect a new bank account</template>
              </Button> -->
            </div>
            <!-- Check -->
            <!-- Check -->
            <div v-if="selectedBankingOption === 'Check'">
              <div>
                <p class="font-inter text-strong mb-2">
                  Please ensure your mailing address is up to date under Profile to receive your
                  check without delay.
                </p>
              </div>
              <!-- <div class="flex flex-col gap-3">
                <div
                  class="bg-bg-canvas rounded-xl px-3 py-4 flex justify-between items-center font-medium"
                >
                  <div>
                    <p class="font-inter text-strong">Make check payable to</p>
                    <p class="font-inter text-strongest text-lg">Phoenix Energy One, LLC</p>
                  </div>
                  <Icon name="Lock" class="h-4.5 w-4.5 text-strong" />
                </div>
                <div class="bg-bg-canvas rounded-xl px-3 py-4 flex justify-between items-center">
                  <div>
                    <p class="font-inter text-strong">
                      Send the check through FedEx, UPS, or regular mail to:
                    </p>
                    <p class="font-inter text-strongest text-lg">
                      Phoenix Energy, 18575 Jamboree Rd, Suite 830 Irvine, CA 92612
                    </p>
                  </div>
                  <Icon name="Lock" class="h-4.5 w-4.5 text-strong" />
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </template>
    <template #modal-footer>
      <div class="flex justify-end gap-2">
        <Button @click="$emit('close-modal')" variant="paper-primary" size="sm" class="">
          <template #label>Cancel</template>
        </Button>
        <Button @click="handleConfirm()" variant="primary-grey" size="sm" class="">
          <template #label>Confirm</template>
        </Button>
      </div>
    </template>
  </Modal>
</template>

<script setup>
// IMPORTS
import { computed, ref, watch } from "vue";
import { Modal, TabView, Form, Icon, Button, BankCard } from "@/components";
import { useCrudStore, useSchemaStore, useUIStore, useDataStore } from "@/stores";
import _ from "lodash";

import checkImg from "@/assets/images/check.png";
import bankImg from "@/assets/images/bank.png";
import { data } from "autoprefixer";

//STORES
const crudStore = useCrudStore();
const schemaStore = useSchemaStore();
const dataStore = useDataStore();
const UIStore = useUIStore();

// EMITS & PROPS
const emit = defineEmits(["close-modal", "refresh"]);
const props = defineProps({
  open: { type: Boolean, required: true },
  modal_config: { type: Object, required: true },
  investment: { type: Object, required: true },
  current_distribution_method: { type: String, required: true },
  current_distribution_account: { type: String, required: true },
});

//REFS
const activeProfileTab = ref("personal.personal_information");
const banks = computed(() => {
  let bank_accounts = dataStore.bank_accounts;

  return [...bank_accounts];
});

const bankingOptions = [
  {
    label: "Bank account",
    value: "ACH",
    icon: bankImg,
  },
  {
    label: "Check",
    value: "Check",
    icon: checkImg,
  },
];

const selectedBankingOption = ref(props.current_distribution_method);
const selectedBankAccount = ref(props.current_distribution_account);

//WATCHERS
watch(
  () => props.open,
  (is_open) => {
    if (is_open) {
      // activeProfileTab.value = props.modal_config.tabs[0].slot_name;
      // set selected options based on current distribution method and account
      // console.log("Current distribution method:", props.current_distribution_method);
      selectedBankingOption.value = props.current_distribution_method;
      selectedBankAccount.value = props.current_distribution_account;
    }
  },
  { immediate: true }
);

// COMPONENT LOGIC AND FUNCTIONS
async function handleConfirm() {
  try {
    let values_changed = checkForChanges();

    if (!values_changed) {
      emit("close-modal");
      return;
    }

    let query = [
      {
        field_name: "record_id",
        operator: "eq",
        value: props.investment.record_id,
      },
    ];

    let update = {
      distribution_method: selectedBankingOption.value,
      distribution_account:
        selectedBankingOption.value === "ACH" ? selectedBankAccount.value : null,
    };

    update = schemaStore.addCreatedUpdatedFields(update, false, true);

    let update_res = await crudStore.update("investments", query, update);

    if (update_res.status !== 200) {
      throw new Error("Failed to update distribution information");
    }

    var success_alert = {
      type: "success",
      message: `Banking information updated successfully.`,
    };
    UIStore.animateNotificationAlert(success_alert);

    emit("refresh");
    emit("close-modal");

    return;
  } catch (e) {
    var alert = {
      type: "error",
      message: `Failed to update banking information.`,
    };
    UIStore.animateNotificationAlert(alert);
    emit("close-modal");
  }
}
function getStateObject(group) {
  if (group == "ID Information") {
    return props.modal_config.object_to_edit.id_info
      ? props.modal_config.object_to_edit.id_info
      : {};
  }
  return props.modal_config.object_to_edit;
}
function checkForChanges() {
  if (
    selectedBankAccount.value !== props.current_distribution_account ||
    selectedBankingOption.value !== props.current_distribution_method
  ) {
    return true;
  }
  return false;
}

function selectOption(value) {
  selectedBankingOption.value = value;
}

function isOptionSelected(value) {
  return selectedBankingOption.value === value;
}

function isBankSelected(bank_id) {
  return selectedBankAccount.value === bank_id;
}

const titleForOption = computed(() => {
  switch (selectedBankingOption.value) {
    case "ACH":
      return "Connected bank accounts";
    case "Check":
      return "You will receive a check in the mail with your earnings.";
    default:
      return "Select a distribution method";
  }
});

// async function handleActivityLog(valid, validation_details) {
//   let status = valid ? "Completed" : "Failed Validation";

//   let log = {
//     step: "Profile Page",
//     substep: "Edit Beneficial Owner",
//     status: status,
//     message: "Editing Beneficial Owner with ID: " + props.modal_config.record_id,
//     url: window.location.href,
//     validation_details: valid ? null : JSON.stringify(validation_details),
//   };

//   log = dataStore.setDefaultFields(log, "investoractivity");
//   await crudStore.insert("investoractivity", [log]);
// }
</script>
